import { Store } from 'store';

const getFlowStep = (store: Store, flowId: string) => store.app.flows[flowId];

export default getFlowStep;
